import React from "react";

interface AddIconProps {
  size?: number | string;
  color?: string;
  className?: string;
  onClick?: () => void;
}

const RightAlignIcon: React.FC<AddIconProps> = ({ size = 22, color = '#1E1F22', className, onClick }) => (
  <svg width="104" height="85" viewBox="0 0 104 85" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_124_11908)">
      <path d="M0 4.89208C0 2.19026 2.19026 0 4.89208 0H99.1079C101.81 0 104 2.19026 104 4.89208V80.1079C104 82.8097 101.81 85 99.1079 85H4.89208C2.19026 85 0 82.8097 0 80.1079V4.89208Z" fill="url(#paint0_linear_124_11908)" fillOpacity="0.05" />
      <rect y="58.7041" width="141.137" height="37.9136" fill="url(#paint1_linear_124_11908)" />
      <rect x="14" y="22" width="70" height="17" fill="#2D6FFF" fillOpacity="0.5" />
      <rect x="26" y="46" width="58" height="17" fill="#2D6FFF" fillOpacity="0.5" />
      <line x1="90.5" y1="14" x2="90.5" y2="71" stroke="#2D6FFF" strokeOpacity="0.5" />
    </g>
    <path d="M4.8916 0.125977H99.1084C101.74 0.126236 103.874 2.25973 103.874 4.8916V80.1084C103.874 82.7403 101.74 84.8738 99.1084 84.874H4.8916C2.25973 84.8738 0.126236 82.7403 0.125977 80.1084V4.8916C0.126235 2.25973 2.25973 0.126236 4.8916 0.125977Z" stroke="url(#paint2_linear_124_11908)" stroke-width="0.251942" />
    <defs>
      <linearGradient id="paint0_linear_124_11908" x1="52" y1="0" x2="52" y2="85" gradientUnits="userSpaceOnUse">
        <stop stopColor="#0050FF" />
        <stop offset="1" stopColor="white" />
      </linearGradient>
      <linearGradient id="paint1_linear_124_11908" x1="70.5683" y1="58.7041" x2="70.5683" y2="96.6177" gradientUnits="userSpaceOnUse">
        <stop stopColor="white" stopOpacity="0" />
        <stop offset="0.559196" stopColor="white" />
        <stop offset="0.782523" stopColor="white" />
        <stop offset="1" stopColor="white" />
      </linearGradient>
      <linearGradient id="paint2_linear_124_11908" x1="52" y1="0" x2="52" y2="85" gradientUnits="userSpaceOnUse">
        <stop stopColor="#0050FF" />
        <stop offset="1" stopColor="#0050FF" stopOpacity="0" />
      </linearGradient>
      <clipPath id="clip0_124_11908">
        <path d="M0 4.89208C0 2.19026 2.19026 0 4.89208 0H99.1079C101.81 0 104 2.19026 104 4.89208V80.1079C104 82.8097 101.81 85 99.1079 85H4.89208C2.19026 85 0 82.8097 0 80.1079V4.89208Z" fill="white" />
      </clipPath>
    </defs>
  </svg>


);

export default RightAlignIcon;
